// -----Main colors-----
export const BUDGET_TEXT_COLOR = '#fff'
export const LIST_ITEM_CHECK_COLOR = '#36C6C8'
export const HOME_PAGE_BACKGROUND_COLOR = '#f9f8f6'
export const HOME_PAGE_TOP_BANNER_BACKGROUND_COLOR = '#F18F02'
export const HOME_PAGE_PRIMARY_BACKGROUND_COLOR = '#fff'
export const OVO_BRAND_GREEN_COLOR = '#0D9828'

export const BORDER_BRANDS_BORDER_COLOR = '#d7d7d7'
export const SUBSCRIPTION_PLAN_BACKGROUND_COLOR = '#fff'
export const FOOTNOTES_ITEM_LABEL_COLOR = '#4472ca'
export const MAIN_HEADER_NUMBER_COLOR = '#ee6f2e'
export const NAVIGATION_ITEM_COLOR = '#303030'
export const MOBILE_NAVIGATION_BORDER_COLOR = '#dedede'
export const NAVIGATION_HEADER_DEFAULT_COLOR = '#fff'
export const NAVIGATION_HEADER_COLLAPSED_COLOR = '#fdf7f1'
export const NAVIGATION_CALL_ENGINEER_TITLE_COLOR = '#000'
export const CALL_BUTTON_TEXT_COLOR = '#fff'
export const HOME_EMERGENCY_BORDER_COLOR = '#e49335'
export const HOME_EMERGENCY_TITLE_BACKGROUND_COLOR = '#fff'

export const ACCORDION_TITLE_COLOR = '#303030'
export const ACCORDION_DESCRIPTION_COLOR = '#444444'
export const ACCORDION_BORDER_COLOR = '#d8d8d8'
export const LIGHT_GREY_COLOR = '#eae6e1'
export const TITLE_LIGHT_BLACK_COLOR = '#303030'
export const SUBSTR_LIGHT_BLACK_COLOR = '#505050'
export const LABEL_BLACK_COLOR = '#303030'
export const ORANGE_GRADIENT = 'linear-gradient(#ffa726, #f08e00)'

export const TEXT_BRIGHT_COLOR = '#fff'
export const TEXT_DARK_COLOR = '#000'

export const CARD_BG_COLOR = '#fff'
export const INPUT_BG_COLOR = '#fff'
export const ICONS_BG = '#fef5f0'

export const FORM_BORDER = '#d2d2dc'
export const COVER_PAGE_HEADER_BORDER_COLOR = '#d7d7d7'
export const TYPOGRAPHY_COLOR = '#303030'

export const SUBSCRIPTION_PLAN_TITLE_COLOR = '#000'
export const CHECK_LIST_ITEM_COLOR = '#444444'

export const PLAN_BORDER_DEFAULT_COLOR = '#d7d7d7'
export const PLAN_SELECTED_COLOR = '#4472ca'
export const PLAN_LAST_COLOR = '#36c6c8'
export const PLAN_DEFAULT_COLOR = '#f9f8f6'
export const PLAN_PRICE_DESCRIPTION_COLOR = '#303030'
export const PLAN_PRICE_COLOR = '#ee6f2e'

export const MOBILE_BUDGET_BACKGROUND_COLOR = '#0094AA'

export const MOBILE_BUDGET_BORDER_COLOR = '#26aaac transparent transparent transparent'

export const MOBILE_CAROUSEL_NAV_BUTTON_BORDER_COLOR = '#d7d7d7'
export const MOBILE_CAROUSEL_NAV_BUTTON_BACKGROUND_COLOR = '#fff'
export const MOBILE_CAROUSEL_NAV_TITLE_COLOR = '#303030'
export const MOBILE_CAROUSEL_NAV_ACTIVE_TITLE_COLOR = '#ee6f2e'

export const PLAN_RATING_BACKGROUND_COLOR = 'rgba(0, 0, 0, 0.05)'
export const PLAN_RATING_ACTIVE_BACKGROUND_COLOR = '#4472ca'
export const MODAL_DESCRIPTION_TEXT_COLOR = '#505050'

export const DISCOUNT_MAIN_COLOR = '#4472ca'
export const DISCOUNT_PROMO_COLOR = '#46BA6C'
export const DISCOUNT_BUTTON_ICON_COLOR = '#000'
export const DISCOUNT_BACKGROUND_COLOR = '#fff'
export const DISCOUNT_ERROR_COLOR = '#ff0000'

export const PRODUCT_INFO_HEADER_DESCRIPTION_COLOR = '#505050'

// -----Buttons-----
export const BUTTON_TEXT_COLOR = '#fff'
export const BUTTON_TEXT_BACKGROUND_COLOR = '#fff'

export const BUTTON_PRIMARY_GRADIENT_TOP_COLOR = '#FA9B3F'
export const BUTTON_PRIMARY_GRADIENT_BOTTOM_COLOR = '#EE6F2E'

export const BUTTON_SECONDARY_GRADIENT_TOP_COLOR = '#497EEE'
export const BUTTON_SECONDARY_GRADIENT_BOTTOM_COLOR = '#395DC7'

export const BUTTON_LINK_COLOR = '#333f48'
export const FOOTER_LINKS_COLOR = '#444'
export const BUTTON_LINK_BORDER_COLOR = '#ee6f2e'
export const FOOTER_SUB_PARAGRAPH_COLOR = '#444444'

export const BUTTON_DEFAULT_COLOR = '#333f48'
export const BUTTON_DEFAULT_BORDER_COLOR = '#36c6c8'

export const BUTTON_DARK_TEXT_COLOR = '#fff'
export const BUTTON_DARK_BACKGROUND_COLOR = '#000'
export const BUTTON_DARK_BORDER_COLOR = '#000'

export const SWITCH_BUTTON_TEXT_COLOR = '#303030'
export const SWITCH_BUTTON_BACKGROUND_COLOR = '#fff'
export const SWITCH_BUTTON_SHADOW_COLOR = '0 0 4px 0 rgba(0, 0, 0, 0.1)'
export const SWITCH_WRAPPER_BACKGROUND_COLOR = '#ebe8e3'
export const SWITCH_WRAPPER_BORDER_COLOR = '#e0e0e0'

export const CAROUSEL_BUTTON_TITLE_COLOR = '#444'
export const CAROUSEL_BUTTON_NAME_COLOR = '#303030'
export const PLAN_DETAILS_DESCRIPTION_COLOR = '#505050'
export const PLAN_DETAILS_TAB_BACKGROUND_COLOR = '#fff'
export const COVER_DOCUMENT_DESCRIPTION_COLOR = '#444444'
export const COVER_DOCUMENT_LINK_COLOR = '#4472ca'
export const OVO_TAB_ITEM_COLOR = '#303030'

// -----Icons-----
export const ICON_CHECKMARK_COLOR = '#4ac6c8'
export const ICON_INFO_BORDER_COLOR = '#D7D7D7'
export const ICON_INFO_TEXT_COLOR = '#444'

// -----Sizes-----
export const EXTRA_LARGE_WIDTH = '1350px'
export const LARGE_DESKTOP_WIDTH = '1200px'
export const DESKTOP_WIDTH = '992px'
export const TABLET_WIDTH = '768px'
export const PHONE_RESOLUTION = '600px'

export const MOBILE_HEADER_DESKTOP_WIDTH = '991px'
export const INLINE_TOOLTIP_LARGE_DESKTOP_WIDTH = '1285px'

export const BUTTON_SMALL_HEIGHT = '44px'
export const BUTTON_MEDIUM_HEIGHT = '50px'
export const BUTTON_LARGE_HEIGHT = '58px'
export const BUTTON_HEIGHT_MOBILE = '44px'

export const BUTTON_SMALL_FONT_SIZE = '14px'
export const BUTTON_MEDIUM_FONT_SIZE = '16px'
export const BUTTON_LARGE_FONT_SIZE = '16px'
export const BUTTON_FONT_SIZE_MOBILE = '14px'

export const LINK_COLOR = '#4472ca'
export const DISABLED_LINK_COLOR = 'rgba(68, 114, 202, 0.6)'
export const OUTLINE_INPUT_COLOR = 'rgba(68, 114, 202, .5)'
export const RED_COLOR = '#f00'
export const INPUT_ERROR_BG = 'rgba(255, 0, 0, 0.05)'
export const CARD_SHADOW = ' 0 2px 30px 0 rgba(0, 0, 0, 0.07)'
export const DROPDOWN_SHADOW = '0px 2px 20px rgba(0, 0, 0, 0.05), 0px 2px 10px rgba(0, 0, 0, 0.05)'
export const DROPDOWN_BACKGROUND = '#FFFFFF'
export const REWIEV_BG_COLOR = '#fff'
export const SUB_TEXT_COLOR_1 = '#444'
export const DOTS_CAROUSEL_ACTIVE = '#e49335'
export const DOTS_CAROUSEL = '#e0e0e0'
export const CONTROL_CAROUSEL_BG = '#FFF'
export const CONTROL_CAROUSEL_BORDER = '#ee6f2e'
export const CAROUSEL_BLOCK_BG = 'linear-gradient(0deg, #fff 50%, #f9f8f6 50%)'
export const RADIO_SQUARE_BORDER = 'solid 1px #d8d8d8'
export const RADIO_SQUARE_BG = '#fff'
export const RADIO_SQUARE_BG_CHECKED = 'rgba(68, 114, 202, 0.1)'
export const RADIO_SQUARE_BORDER_CHECKED = 'solid 1px #4472ca'
export const RADIO_SQUARE_COLOR = '#4472ca'
export const RADIO_LABEL_COLOR = '#1A1716'

export const SALES_FUNNEL_MAIN_COLOR = '#D65A1B'
export const SALES_FUNNEL_DARK_TITLE_COLOR = '#5C534E'